import React from 'react';
import { fromUnixTime } from 'date-fns';
import { isOpenEdition } from '@components/Song/MintComponents/shared-helpers';
import { Badges } from '../Badges';
import type { PresaleDetails, PublicSaleDetails } from './useMintState';

export function EditionBadges({
  selectedSchedule,
  publicSaleCutOff,
}: {
  selectedSchedule: NonNullable<PublicSaleDetails | PresaleDetails>;
  publicSaleCutOff: boolean;
}) {
  const isOe = isOpenEdition(selectedSchedule.maxSupply) && !publicSaleCutOff;
  const isPresale = 'merkleRoot' in selectedSchedule;

  const maxSupply = (() => {
    if (publicSaleCutOff) {
      return 'canMintPublicSale' in selectedSchedule
        ? selectedSchedule.maxMintableLower
        : selectedSchedule.maxSupply;
    }
    return selectedSchedule.maxSupply;
  })();

  return (
    <Badges
      isOpenEdition={isOe}
      isSaleRunning={selectedSchedule.saleOngoing}
      isSoldOut={selectedSchedule.isSoldOut}
      saleEnded={selectedSchedule.saleEnded}
      isPresale={isPresale}
      expiryTimestamp={fromUnixTime(selectedSchedule.endTime).getTime()}
      totalMinted={selectedSchedule.totalMinted}
      maxValue={maxSupply}
    />
  );
}
